/**
 * Action types for fetching group data.
 *
 * These constants represent different stages of the group data fetching process
 */
export const AP_LIST_REQUEST_GET = 'AP_LIST_REQUEST_GET';
export const AP_LIST_GET_SUCCESS = 'AP_LIST_GET_SUCCESS';
export const AP_LIST_GET_FAIL = 'AP_LIST_GET_FAIL';
export const ADD_AP_RESULT = 'ADD_AP_RESULT';
export const errorConstants = {
	DEVICE_NOT_FOUND_IN_SYSTEM: 'DEVICE_NOT_FOUND_IN_SYSTEM',
	AP_NAME_ALREADY_EXISTS: 'AP_NAME_ALREADY_EXISTS',
	DEVICE_ALREADY_CLAIMED: 'DEVICE_ALREADY_CLAIMED',
};
export const AP_SEARCH_REQUEST_GET = 'AP_SEARCH_REQUEST_GET';
export const AP_SEARCH_GET_SUCCESS = 'AP_SEARCH_GET_SUCCESS';
export const AP_SEARCH_GET_FAIL = 'AP_SEARCH_GET_FAIL';

export const AP_FIRMWARE_REQUEST_GET = 'AP_FIRMWARE_REQUEST_GET';
export const AP_FIRMWARE_GET_SUCCESS = 'AP_FIRMWARE_GET_SUCCESS';
export const AP_FIRMWARE_GET_FAIL = 'AP_FIRMWARE_GET_FAIL';
export const RESET_STATE = 'RESET_STATE';

export const AP_REQUEST_DELETE = 'AP_REQUEST_DELETE';
export const AP_DELETE_SUCCESS = 'AP_DELETE_SUCCESS';
export const AP_DELETE_FAIL = 'AP_DELETE_FAIL';
export const RESET_AP_DELETE = 'RESET_AP_DELETE';

export const AP_REQUEST_ADD = 'AP_REQUEST_ADD';
export const AP_ADD_SUCCESS = 'AP_ADD_SUCCESS';
export const AP_ADD_FAIL = 'AP_ADD_FAIL';
export const RESET_AP_ADD = 'RESET_AP_ADD';

export const AP_REQUEST_UPDATE = 'AP_REQUEST_UPDATE';
export const AP_UPDATE_SUCCESS = 'AP_UPDATE_SUCCESS';
export const AP_UPDATE_FAIL = 'AP_UPDATE_FAIL';
export const RESET_AP_UPDATE = 'RESET_AP_UPDATE';

export const BULK_AP_REQUEST_POST = 'BULK_AP_REQUEST_POST';
export const BULK_AP_RESPONSE_POST_FAIL = 'BULK_AP_RESPONSE_POST_FAIL';
export const BULK_ADD_AP_RESPONSE_SUCCESS = 'BULK_ADD_AP_RESPONSE_SUCCESS';
export const BULK_ADD_AP_RESET_SUCCESS_MSG_OR_ERROR =
	'BULK_ADD_AP_RESET_SUCCESS_MSG_OR_ERROR';
export const RESET_BULK_ADD_AP = 'RESET_BULK_ADD_AP';
export const BULK_ADD_AP_SUCCESS_MSG_RESPONSE =
	'BULK_AP_UPLOAD_INITIATED_SUCCESSFULLY';

export const AP_REMOTE_ENABLE = 'AP_REMOTE_ENABLE';
export const AP_REMOTE_ENABLE_SUCCESS = 'AP_REMOTE_ENABLE_SUCCESS';
export const AP_REMOTE_ENABLE_FAIL = 'AP_REMOTE_ENABLE_FAIL';

export const AP_ADD_SNAPSHOT = 'AP_ADD_SNAPSHOT';
export const AP_ADD_SNAPSHOT_SUCCESS = 'AP_ADD_SNAPSHOT_SUCCESS';
export const AP_ADD_SNAPSHOT_FAIL = 'AP_ADD_SNAPSHOT_FAIL';

export const AP_REBOOT = 'AP_REBOOT';
export const AP_REBOOT_SUCCESS = 'AP_REBOOT_SUCCESS';
export const AP_REBOOT_FAIL = 'AP_REBOOT_FAIL';

export const AP_BLINK = 'AP_BLINK';
export const AP_BLINK_SUCCESS = 'AP_BLINK_SUCCESS';
export const AP_BLINK_FAIL = 'AP_BLINK_FAIL';

export const AP_ADD_TRIGGER = 'AP_ADD_TRIGGER';
export const SHOW_AP_MODAL = 'SHOW_AP_MODAL';

export const POST_MOVE_AP = 'POST_MOVE_AP';
export const POST_MOVE_AP_FAIL = 'POST_MOVE_AP_FAIL';
export const POST_MOVE_AP_SUCCESS = 'POST_MOVE_AP_SUCCESS';
export const POST_MOVE_AP_SUCCESS_MSG = 'AP_MOVE_DONE_SUCCESSFULLY';
export const RESET_MOVE_AP = 'RESET_MOVE_AP';

export const CRITICAL_ALARM_TRIGGER = 'CRITICAL_ALARM_TRIGGER';
export const CRITICAL_ALARM_TRIGGER_HOME = 'CRITICAL_ALARM_TRIGGER_HOME';
export const CRITICAL_ALARM_TRIGGER_AP = 'CRITICAL_ALARM_TRIGGER_AP';
export const CRITICAL_ALARM_TRIGGER_SWITCH = 'CRITICAL_ALARM_TRIGGER_SWITCH';
export const ALARM_SUMMARY_VIEW_ALL_TRIGGER = 'ALARM_SUMMARY_VIEW_ALL_TRIGGER';
export const DEVICE_REQUEST_BY_SITE_GET = 'DEVICE_REQUEST_BY_SITE_GET';
export const DEVICE_RESPONSE_BY_SITE_GET_SUCCESS =
	'DEVICE_RESPONSE_BY_SITE_GET_SUCCESS';
export const DEVICE_RESPONSE_BY_SITE_GET_FAIL =
	'DEVICE_RESPONSE_BY_SITE_GET_FAIL';
export const APSWITCH_REQUEST_GET = 'APSWITCH_REQUEST_GET';
export const APSWITCH_RESPONSE_GET_SUCCESS = 'APSWITCH_RESPONSE_GET_SUCCESS';
export const APSWITCH_RESPONSE_GET_FAIL = 'APSWITCH_RESPONSE_GET_FAIL';

export const AP_DASH_DOWNLOAD = 'AP_DASH_DOWNLOAD';
export const AP_DASH_DOWNLOAD_SUCCESS = 'AP_DASH_DOWNLOAD_SUCCESS';

export const AP_SNAPSHOT_DOWNLOAD = 'AP_SNAPSHOT_DOWNLOAD';
export const AP_SNAPSHOT_DOWNLOAD_FAIL = 'AP_SNAPSHOT_DOWNLOAD_FAIL';

export const DELETE_AP_SNAPSHOT = 'DELETE_AP_SNAPSHOT';
export const DELETE_AP_SNAPSHOT_SUCCESS = 'DELETE_AP_SNAPSHOT_SUCCESS';
export const DELETE_AP_SNAPSHOT_FAIL = 'DELETE_AP_SNAPSHOT_FAIL';

export const GET_AP_SNAPSHOT = 'GET_AP_SNAPSHOT';
export const GET_AP_SNAPSHOT_SUCCESS = 'GET_AP_SNAPSHOT_SUCCESS';
export const GET_AP_SNAPSHOT_FAIL = 'GET_AP_SNAPSHOT_FAIL';

export const GET_AP_CONFIG_REQUEST = 'GET_AP_CONFIG_REQUEST';
export const GET_AP_CONFIG_REQUEST_SUCCESS = 'GET_AP_CONFIG_REQUEST_SUCCESS';
export const GET_AP_CONFIG_REQUEST_FAIL = 'GET_AP_CONFIG_REQUEST_FAIL';
export const RESET_AP_CONFIG_DATA = 'RESET_AP_CONFIG_DATA';

export const DOWNLOAD_AP_CONFIG_REQUEST = 'DOWNLOAD_AP_CONFIG_REQUEST';
export const DOWNLOAD_AP_CONFIG_REQUEST_SUCCESS =
	'DOWNLOAD_AP_CONFIG_REQUEST_SUCCESS';
export const DOWNLOAD_AP_CONFIG_REQUEST_FAIL =
	'DOWNLOAD_AP_CONFIG_REQUEST_FAIL';

export const RESET_DOWNLOAD_CONFIG_DATA = 'RESET_DOWNLOAD_CONFIG_DATA';
export const SAVE_AP_GRAPH_WIDGET = 'SAVE_AP_GRAPH_WIDGET';
export const DOWNLOAD_AP_FILE = 'DOWNLOAD_AP_FILE';
export const DOWNLOAD_AP_SUCCESS = 'DOWNLOAD_AP_SUCCESS';
export const DOWNLOAD_AP_FAIL = 'DOWNLOAD_AP_FAIL';
export const CONFIG_AUDIT_ADD = 'CONFIG_AUDIT_ADD';
export const CONFIG_AUDIT_ADD_SUCCESS = 'CONFIG_AUDIT_ADD_SUCCESS';
export const CONFIG_AUDIT_ADD_FAIL = 'CONFIG_AUDIT_ADD_FAIL';

export const CONFIG_AUDIT_LIST_REQUEST_GET = 'CONFIG_AUDIT_LIST_REQUEST_GET';
export const CONFIG_AUDIT_LIST_GET_SUCCESS = 'CONFIG_AUDIT_LIST_GET_SUCCESS';
export const CONFIG_AUDIT_LIST_GET_FAIL = 'CONFIG_AUDIT_LIST_GET_FAIL';

export const CONFIG_AUDIT_DELETE = 'CONFIG_AUDIT_DELETE';
export const CONFIG_AUDIT_DELETE_SUCCESS = 'CONFIG_AUDIT_DELETE_SUCCESS';
export const CONFIG_AUDIT_DELETE_FAIL = 'CONFIG_AUDIT_DELETE_FAIL';

export const DOWNLOAD_CONFIG_AUDIT = 'DOWNLOAD_CONFIG_AUDIT';
export const DOWNLOAD_CONFIG_AUDIT_SUCCESS = 'DOWNLOAD_CONFIG_AUDIT_SUCCESS';
export const DOWNLOAD_CONFIG_AUDIT_FAIL = 'DOWNLOAD_CONFIG_AUDIT_FAIL';

export const CHILD_LIST_REQUEST_BY_SITE_GET = 'CHILD_LIST_REQUEST_BY_SITE_GET';
export const CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS = 'CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS';
export const CHILD_LIST_RESPONSE_BY_SITE_GET_FAIL = 'CHILD_LIST_RESPONSE_BY_SITE_GET_FAIL';
